import { createClient } from "@supabase/supabase-js";

import { supabaseAnonKey, supabaseUrl } from "@/config/env";
import { Database } from "./types";

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  /**
   * Msw cannot intercept the default cross-fetch
   * @link https://github.com/supabase/supabase/issues/27656
   */
  ...(import.meta.env.NODE_ENV === "test" ? { global: { fetch: (...args) => fetch(...args) } } : {}),
  realtime: { worker: true },
});
